<template>
  <template v-if="!product.title.includes('E-Gift Card')">
    <div v-if="selectedVariant">
      <button
        v-if="selectedVariant.available"
        data-add-to-cart
        class="btn btn--secondary btn--medium pm__atc"
        @click="atc()"
        :disabled="isATCDisabled"
      >
        ADD TO CART
      </button>
      <div v-else>
        <button
          v-if="!selectedFirstOption.bis"
          data-add-to-cart
          disabled
          class="btn btn--secondary btn--medium pm__atc"
        >
          OUT OF STOCK
        </button>
        <button v-else class="btn btn--secondary btn--medium pm__atc" @click="bisDrawer">
          Notify Me When Available
        </button>
      </div>
    </div>
    <div v-else>
      <button
        data-add-to-cart
        @mouseover="mouseOverUnselectBtn = true"
        @mouseleave="mouseOverUnselectBtn = false"
        class="btn btn--secondary btn--medium pm__atc"
      >
        <span v-if="!mouseOverUnselectBtn">ADD TO CART</span>
        <span v-else>SELECT {{ unselectBtnName }}</span>
      </button>
    </div>
  </template>
  <template v-else>
    <div class="recipient__wrapper">
      <div class="recipient__input-wrapper">
        <input v-model="isReciepientSelect" type="checkbox" id="recipientCheck" class="recipient__input" />
        <label for="recipientCheck" class="recipient__label">I want to send this as a gift</label>
      </div>
      <form v-if="isReciepientSelect" class="recipient__info" @submit.prevent="recipientAtc">
        <label data-name="Recipient Name"
          >Recipient Name <span class="required__field">*</span>
          <input v-model="recipientName" type="text" placeholder="Recepient Name" required="" />
        </label>
        <label data-name="Recipient Email"
          >Recipient Email <span class="required__field">*</span>
          <input
            v-model="recipientEmail"
            pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$"
            type="email"
            placeholder="Recipient Email"
            required=""
          />
        </label>
        <label data-name="Message"
          >Message (Optional)
          <textarea v-model="customMessage" rows="10" maxlength="200" placeholder="Message"></textarea>
        </label>
        <label data-name="Date To Send"
          >Date To Send (Optional)
          <input
            v-model="scheduledDate"
            :min="minDate"
            type="date"
            placeholder="Date To Send (Optional)"
            data-date-format="DD MMMM YYYY"
          />
        </label>
        <button type="submit" data-add-to-cart class="btn btn--secondary btn--medium pm__atc">ADD TO CART</button>
      </form>
      <button v-else data-add-to-cart class="btn btn--secondary btn--medium pm__atc" @click="atc()">ADD TO CART</button>
    </div>
  </template>
</template>

<script setup>
  import { computed, toRefs, ref, onMounted } from 'vue';

  const props = defineProps({
    product: {
      type: Object,
      default: () => ({}),
    },

    productForm: {
      type: Object,
      default: () => ({}),
    },

    selectedVariant: {
      type: Object,
      default: () => ({}),
    },

    selectedFirstOption: {
      type: Object,
      default: () => ({}),
    },

    isPDPstickyBar: {
      type: Boolean,
      default: false,
    },
  });

  const { product, productForm, selectedVariant, selectedFirstOption, isPDPstickyBar } = toRefs(props);
  let mouseOverUnselectBtn = ref(false);
  const isReciepientSelect = ref(false);
  const recipientName = ref('');
  const recipientEmail = ref('');
  const scheduledDate = ref(new Date().toISOString().split('T')[0]);
  const customMessage = ref('');
  const emit = defineEmits(['product-added', 'on-atc-state-change']);
  const cartItems = ref(window.cartItems);

  onMounted(() => {
    window.addEventListener('cartItemsUpdated', updateCartItems);
  });

  const unselectBtnName = computed(() => {
    const { options } = product.value;
    let name;
    for (let option in options) {
      if (!productForm.value[options[option].name]) {
        name = options[option].name;
        break;
      }
    }
    return name;
  });

  const minDate = computed(() => {
    return new Date().toISOString().split('T')[0];
  });

  const isATCDisabled = computed(() => {
    const { id, inventory_quantity } = selectedVariant.value;
    let flag = false;

    if (id && cartItems.value?.length) {
      const selCartItem = cartItems.value.find((item) => item.id == id);
      flag = selCartItem?.quantity === inventory_quantity;
    }

    emit('on-atc-state-change', flag);
    return flag;
  });

  const updateCartItems = () => {
    cartItems.value = window.cartItems;
  };

  const bisDrawer = () => {
    window.toggleDrawer(true, 'BISModal', {
      productId: product.value.id,
      variantId: selectedVariant.value.id,
      bisDate: selectedFirstOption.value.bisDate,
    });
  };

  const atc = async () => {
    if (isPDPstickyBar.value) {
      emit('product-added');
    }
    window.openCart({ cartConfirmation: true });
    await window.Additem({
      id: selectedVariant.value.id,
      quantity: 1,
      properties: {
        ...(product.value.final_sale_msg && { Note: product.value.final_sale_msg }),
      },
    });
  };

  const recipientAtc = async () => {
    if (isPDPstickyBar.value) {
      emit('product-added');
    }
    window.openCart({ cartConfirmation: true });
    await window.Additem({
      id: selectedVariant.value.id,
      quantity: 1,
      properties: {
        ...(product.value.final_sale_msg && { Note: product.value.final_sale_msg }),
        __shopify_send_gift_card_to_recipient: 'on',
        'Recipient name': recipientName.value,
        'Recipient email': recipientEmail.value,
        ...(customMessage.value.length && { Message: customMessage.value }),
        'Send on': scheduledDate.value,
      },
    });

    isReciepientSelect.value = false;
    recipientName.value = '';
    recipientEmail.value = '';
    customMessage.value = '';
    scheduledDate.value = minDate.value;

    // This is for ADA task i.e retaining focus on checkbox.
    if (product.value?.title?.includes('E-Gift Card') && isReciepientSelect.value === false) {
      const recipientCheckbox = document.querySelector('#recipientCheck');
      recipientCheckbox?.focus();
    }
  };
</script>
